module.exports = __webpack_public_path__ + "img/logo_icaycc_blanco.a0637d12.png";